// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"2ba2db34","229":"d979aeef","643":"d204f29c","695":"a22d07f7","709":"a9fa08e4"}[chunkId] + ".chunk.css";
};